import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'ScorePane' })({
    container: {
        width: 282,
        '@media (max-width: 960px)': {
            width: 'initial'
        }
    },
    pane: {
        display: 'flex',
        justifyContent: 'space-between',
        padding: '17px 20px',
        borderRadius: 18,
        marginTop: 20,
        userSelect: 'none',
        '& p': {
            fontWeight: 600
        }
    },
    accent: {
        width: 6,
        height: 24,
        borderRadius: 100,
        marginRight: 12
    },
    vector: {
        marginTop: 20,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: 12,
        border: '1px solid #EEEEEE',
        borderRadius: 18,
        '& p': {
            wordBreak: 'break-all',
            whiteSpace: 'pre-wrap',
            flex: 1,
            borderRight: '1px solid #EEE',
            marginRight: 12
        }
    },
    vectorItem: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '12px 20px',
        background: '#FAFAFA',
        marginTop: 2,
        '& :nth-child(2)': {
            fontWeight: 600,
            textTransform: 'lowercase',
            '&:first-letter': {
                textTransform: 'uppercase' //To Capitalize case if it already uppercase
            }
        },
        '&:last-child': {
            borderBottomLeftRadius: 18,
            borderBottomRightRadius: 18
        }
    }
});
